import { newDocumentoSelector } from "features/Crear/redux/selectors/newDocumentoSelectors"
import {
  getNewDocumentCurrency,
  newDocumentoSettingsSelector,
} from "features/Crear/redux/selectors/newDocumentoSettingsSelectors"
import { useSelector } from "hooks/useSelector"
import { Button } from "primereact/button"
import { useTranslation } from "react-i18next"
import { useCurrency } from "../../../../common/hooks/useCurrency"

export const COLUMNS = (t: $TSMigrationFixMe) => [
  `${t("crear.facturaRec.headerConcept")}`,
  `${t("crear.facturaRec.headerCant")}`,
  `${t("crear.facturaRec.headerPrice")}`,
  `${t("crear.facturaRec.headerImp")}`,
  `${t("crear.facturaRec.headerImport")}`,
]

export const COLUMNS_SIN_VALORAR = (t: $TSMigrationFixMe) => [
  `${t("crear.facturaRec.headerConcept")}`,
  `${t("crear.facturaRec.headerCant")}`,
]

const ConceptosTableHeader = ({
  sinValorar,
  handleOnCreateConcepto,
  columns,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const documento = useSelector(newDocumentoSelector)
  const { colorSelected } = useSelector(newDocumentoSettingsSelector)

  const { currencyList } = useCurrency()
  const currency = useSelector(getNewDocumentCurrency)
  const currencyData = currencyList?.find(
    ({ abreviatura }) => abreviatura === currency
  )

  let columnsToShow = columns

  const COLUMNS_NEW_FACTURA = [
    `${t("crear.facturaRec.headerConcept")}`,
    `${t("crear.facturaRec.headerCant")}`,
    // @ts-expect-error TS(2339): Property 'simbolo' does not exist on type 'never'.
    `${t("crear.facturaRec.headerPrice")} ${currencyData?.simbolo}`,
    `${t("crear.facturaRec.headerImp")}`,
    // @ts-expect-error TS(2339): Property 'simbolo' does not exist on type 'never'.
    `${t("crear.facturaRec.headerImport")} ${currencyData?.simbolo}`,
  ]

  if (!columnsToShow) {
    columnsToShow = sinValorar ? COLUMNS_SIN_VALORAR(t) : COLUMNS_NEW_FACTURA
  }

  return (
    <thead
      className={`header-blue ${
        !documento.conceptos?.length && "opacity-5"
      } !tw-w-full`}
    >
      <tr
        className=''
        style={{ backgroundColor: colorSelected }}
      >
        {columnsToShow?.map((header: $TSMigrationFixMe) => (
          <th
            className='px-3 text-header-table'
            key={header}
          >
            {header}
          </th>
        ))}

        {documento.conceptos?.length > 0 && (
          <th className='position-relative'>
            <Button
              className='add-row'
              style={{
                backgroundColor: colorSelected,
                borderColor: colorSelected,
              }}
              icon='bi bi-plus'
              onClick={handleOnCreateConcepto}
            />
          </th>
        )}
      </tr>
    </thead>
  )
}

export default ConceptosTableHeader
